import { Checkbox, Flex, ListItemOption, Select, isNullish } from "@theorgchartdev/storybook";
import { RuleInput } from "@/appComponents/Blocks/Composites/RuleInput/RuleInput";
import { appstr } from "@coreapp/utils/appstr";
import { QRule } from "@coreapp/CoreApp/QRule";
import { UIRuleError } from "@/appComponents/Blocks/Composites/RuleInput/ruleErrors";
import { enumMatchSubs } from "@coreapp/constants";

const NO_RULE = "no_rule";
const BASIC_RULE = "basic_rule";
const COMPLEX_RULE = "complex_rule";

type Mode = typeof NO_RULE | typeof BASIC_RULE | typeof COMPLEX_RULE;

const getModeValue = (rule: QRule | null): Mode => {
  if (isNullish(rule)) return NO_RULE;
  return rule.GetIsComplex() ? COMPLEX_RULE : BASIC_RULE;
};

const BuildModeOptions = (onClick: (item: ListItemOption) => void): ListItemOption[] => [
  { label: appstr("No rule"), value: NO_RULE, clickHandler: onClick },
  { label: appstr("BasicRule"), value: BASIC_RULE, clickHandler: onClick },
  { label: appstr("ComplexRule"), value: COMPLEX_RULE, clickHandler: onClick }
];

interface Props {
  rule: QRule | null;
  setRule: (rule: QRule | null) => void;
  errors: UIRuleError | null;
}

export const CustomChartRuleInput = (props: Props) => {
  const mode = getModeValue(props.rule);

  const handleModeChange = ({ value }: ListItemOption) => {
    if (value === NO_RULE) {
      props.setRule(null);
      return;
    }
    const isComplex = value === COMPLEX_RULE;
    if (isNullish(props.rule)) {
      const rule = new QRule();
      rule.InitRule(enumMatchSubs.matchonly);
      rule.AddRulePair("", "", "", "equals", "");
      rule.SetIsComplex(isComplex);
      props.setRule(rule);
    } else {
      const rule = props.rule.Clone();
      rule.SetIsComplex(isComplex);
      props.setRule(rule);
    }
  };

  const handleIncludeFilteredChange = () => {
    if (isNullish(props.rule)) return;
    const rule = props.rule.Clone();
    rule.SetIncludeFiltered(!rule.GetIncludeFiltered());
    props.setRule(rule);
  };

  return (
    <Flex direction="column" gap="12px" width="100%">
      <Select
        selectSize="medium"
        listProps={{ fillWidth: true, optionSize: "medium" } as any}
        value={mode}
        options={BuildModeOptions(handleModeChange)}
        id="ocn-custom-chart-filter-mode-select"
      />
      {mode !== NO_RULE && (
        <>
          <RuleInput
            editing
            allowHierarchyFields={false}
            rule={props.rule}
            setRule={props.setRule}
            basicRuleInputProps={{
              rulePairProps: {
                selectSize: "medium",
                requiredMarker: true
              }
            }}
            errorsObject={props.errors ?? { hasError: false }}
          />
          <Checkbox
            id="includefiltered"
            label={appstr("includefiltered")}
            size="small"
            checked={props.rule?.GetIncludeFiltered() ?? false}
            onToggle={handleIncludeFilteredChange}
          />
        </>
      )}
    </Flex>
  );
};
